import SavedQueriesPage from './Page';
export default SavedQueriesPage;
